import { Routes } from '@angular/router';
import { ContainerComponent } from './container/container.component';
import { VoivodeshipsComponent } from './components/voivodeships/voivodeships.component';
import { SalonsComponent } from './components/salons/salons.component';

export const PARTNER_SALONS_ROUTES: Routes = [
    {
        path: '',
        component: ContainerComponent,
        children: [
            {
                path: '',
                component: VoivodeshipsComponent,
            },
            {
                path: ':voivodeship',
                component: SalonsComponent,
            },
        ],
    },
];
